import React from 'react';

import SettingsPage from 'Pages/Settings/SettingsPage';

import ViewCmsElementRecords from "Components/Utilities/ViewCmsElementRecords";
import {PrimaryButton} from "Components/Button";
import {ModalTrigger} from "Components/Modal";
import Authenticated from "Components/Layouts/TTS";
import {translation} from "Services/TranslationHelpers";
import CreateCmsElementRecordModal from "Components/Partials/Modals/CreateCmsElementRecordModal";
import {faClipboardCheck} from "@fortawesome/free-solid-svg-icons/faClipboardCheck";

export default class HrStaffForms extends React.Component {

    /**
     * @method render
     * @return {*}
     */
    render () {
        const user_id = this.props.match?.params?.user ?? null;

        return (
            <Authenticated title="Staff From" titleIcon={faClipboardCheck}>
                <div className="mb-6">
                    <ModalTrigger
                        component={CreateCmsElementRecordModal}
                        props={{
                            showElementsDropdown: true,
                            element_id: null,
                            element_record_id: null,
                            service_user_id: null,
                            staff_form: true,
                            staff_user_id: user_id,
                        }}
                    >
                        <PrimaryButton
                            className="font-league-spartan font-bold text-xl"
                            text={translation('cms', 'health_and_safety_submit')}
                        />
                    </ModalTrigger>
                </div>

                <ViewCmsElementRecords
                    staff_form={true}
                    user_id={user_id}
                />
            </Authenticated>
        );
    }
}
